import { render } from "./ClaimSubmission.vue?vue&type=template&id=aed1ad60&ts=true"
import script from "./ClaimSubmission.vue?vue&type=script&lang=ts"
export * from "./ClaimSubmission.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__